"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _vueFinder = require("@jledentu/vue-finder");

var _validate = require("@/utils/validate");

//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Test',
  components: {
    Finder: _vueFinder.Finder
  },
  data: function data() {
    return {
      theme: {
        primaryColor: '#a6bfe4',
        arrowColor: '#0B5BAC'
      },
      affiliations: [],
      customAffiliations: {},
      listAllIdsFromLastItem: [],
      items: {},
      pathToListItem: [],
      selectedId: null,
      disabledButton: true
    };
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _affiliation, createAffiliationTree, element;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              createAffiliationTree = function _ref(affiliation) {
                return {
                  id: affiliation.id,
                  label: affiliation.name,
                  children: affiliation.affiliations.map(function (affiliationNestedItem) {
                    return createAffiliationTree(affiliationNestedItem);
                  })
                };
              };

              _context.next = 3;
              return this.$store.dispatch('company/fetchAffiliation');

            case 3:
              _affiliation = this.$store.getters.affiliations;
              // /データを Finder の形式に変換する
              element = {
                id: 'root',
                children: _affiliation.map(function (item) {
                  return createAffiliationTree(item);
                })
              };
              this.customAffiliations = element;
              this.affiliations = this.$store.getters.affiliations;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    onExpand: function onExpand(_ref2) {
      var expanded = _ref2.expanded,
          sourceEvent = _ref2.sourceEvent;
      var selected = expanded.join().split(',')[expanded.length - 1];
      this.selectedId = selected;
      this.disabledButton = false;
    },
    getRequiredData: function getRequiredData() {
      var valueSelected = this.selectedId;
      var affiliations = this.affiliations;
      var _pathToListItem = [];
      var _listAllIdFromLastItem = [];

      function subReloadAffiliation(_affiliation, accept) {
        // acceptは、父親のIDを取得しないことを意味します
        if (accept && _affiliation.id >= 0) {
          _listAllIdFromLastItem.push(_affiliation.id);
        }

        return _affiliation.affiliations.map(function (ite) {
          return subReloadAffiliation(ite, true);
        });
      }

      function reloadAffiliation(affiliation) {
        // eslint-disable-next-line eqeqeq
        if (affiliation.id == valueSelected) {
          var pathFromDepth = (0, _validate.depthFirstSearch)(affiliations, [affiliation]);
          _pathToListItem = pathFromDepth;
          subReloadAffiliation(affiliation, true);
        }

        return affiliation.affiliations.map(function (item) {
          return reloadAffiliation(item);
        });
      }

      affiliations.map(function (i) {
        return reloadAffiliation(i);
      }); // eslint-disable-next-line eqeqeq

      if (valueSelected == -1) {
        // （-1）がすべてです
        _listAllIdFromLastItem = []; // eslint-disable-next-line eqeqeq
      } else if (valueSelected != -1 && valueSelected < 0) {
        // （全てグループ）の子供たち
        subReloadAffiliation(_pathToListItem[_pathToListItem.length - 2], false);
      }

      this.pathToListItem = _pathToListItem;
      this.listAllIdsFromLastItem = _listAllIdFromLastItem;
    },
    sendData: function () {
      var _sendData = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getRequiredData();

              case 2:
                _context2.next = 4;
                return this.$store.commit('company/pathToListItem', this.pathToListItem);

              case 4:
                _context2.next = 6;
                return this.$store.commit('company/getDataSearchAffiliation', this.listAllIdsFromLastItem);

              case 6:
                this.$emit('panretToggleDrawer');

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendData() {
        return _sendData.apply(this, arguments);
      }

      return sendData;
    }()
  }
};
exports.default = _default;